
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Performance optimization: Preload critical resources
const preloadCriticalResources = () => {
  // Preload hero images
  const heroImage = new Image();
  heroImage.src = 'https://public.readdy.ai/ai/img_res/3f48e570e2c0b18a5aee1fe4cec0e3a5.jpg';
  
  // Preload navigation icons
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = 'https://cdn.jsdelivr.net/npm/remixicon@4.0.0/fonts/remixicon.css';
  link.as = 'style';
  document.head.appendChild(link);
};

// Initialize preloading
preloadCriticalResources();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
